import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-4xl" aria-hidden="true"></i>
      </div>
      <h1 className="mt-6 text-3xl font-extrabold text-foreground-950 md:text-4xl">404 · 页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm text-foreground-600 md:text-base">
        你访问的地址不存在或已被移动。别担心，下面的入口可以带你回到漫蛙2的内容世界。
      </p>
      <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/news"
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-newspaper-line"></i>
          浏览资讯
        </Link>
        <Link
          to="/community"
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-chat-smile-2-line"></i>
          前往社区
        </Link>
      </div>
    </div>
  );
}